import { render } from "./HiddenField.vue?vue&type=template&id=819b2da8"
import script from "./HiddenField.vue?vue&type=script&lang=js"
export * from "./HiddenField.vue?vue&type=script&lang=js"

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HiddenField.vue"]])

export default __exports__